import React, { memo } from "react";
import Routes from "./routes";

// import "./App.css";

const App: React.FC = memo(() => {
  return <Routes />;
});

export default App;
